<div id="sub-header">
  <nav (click)="closeSearchBurger()">
    <button (click)="changeEntityType(true)" theme="nav"
            [ngClass]="[this.isCandidate ? 'checked' : 'unchecked']" appRipple>Candidate
    </button>
    <button (click)="changeEntityType(false)" theme="nav"
            [ngClass]="[!this.isCandidate ? 'checked' : 'unchecked']" appRipple>Contact
    </button>
    <h2>Estimated number of <span class="green">{{isCandidate ? "Candidate" : "Contact"}}</span> records that will be
      found:
      <span class="green">{{dataCleanerService.numRecordsFound}}</span>
      <i class="bhi-info"
         matTooltip="Estimates include records with empty and invalid field values. Selecting 'No Future Tasks' or 'No Future Appointments' will not affect this estimate."
         matTooltipClass="mat-tooltip-wide"></i>
      <span class="red" *ngIf="dataCleanerService.numRecordsFoundTooMany()"> Too many records found, please adjust your query.</span>
    </h2>
  </nav>
  <app-previous-searches-burger [groupedSearches]="groupedSearches"
                                (reportSearch)="selectSearch($event)"
                                (deleteSearch)="removeSearch($event)">
  </app-previous-searches-burger>
</div>
<div class="content" (click)="closeSearchBurger()">
    <app-candidate-options (hotListName)="hotListName = $event"
                           [isCandidate]="isCandidate"
                           [isLoading]="isLoading"
                           (scheduledSearchEvent)="onScheduledSearch()"
                           (runSearchRequested)="runSearch($event)"
                           [showFilterOptions]="showFilterOptions"
                           [currentSearchId]="currentSearchId"
                           (searchIdChange)="handleSearchIdChange($event)">
    </app-candidate-options>
    <app-results-table [searchResults]="searchResults"
                       [columns]="columns"
                       [isCandidate]="isCandidate"
                       [showResultsTable]="showResultsTable"
                       [currentSearchId]="currentSearchId"
                       [isLoading]="isLoadingResults">
    </app-results-table>
</div>
